import { render, staticRenderFns } from "./general.vue?vue&type=template&id=ce36d332&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce36d332')) {
      api.createRecord('ce36d332', component.options)
    } else {
      api.reload('ce36d332', component.options)
    }
    module.hot.accept("./general.vue?vue&type=template&id=ce36d332&", function () {
      api.rerender('ce36d332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/tabs/general.vue"
export default component.exports